import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "../services/api";
import ProductCard from "../components/product/ProductCard";
import { useFavorites } from "../context/FavoritesContext";
import { Skeleton } from "../components/ui/skeleton";

export default function Favorites() {
  const { ids } = useFavorites();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/users/favorites").then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [ids.length]);

  return (
    <div className="container-queen pt-32 pb-24" id="main">
      <p className="label-eyebrow text-[#C5A880] mb-2">Sélection Personnelle</p>
      <h1 className="font-display text-[#111111] mb-10 text-4xl sm:text-5xl">Mes Favoris</h1>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="w-full rounded-2xl aspect-[4/5]" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-24 bg-[#F8F8F6] rounded-3xl border border-[#EAE8E4]">
          <div className="w-16 h-16 rounded-full bg-white grid place-items-center mx-auto text-[#111111] shadow-sm">
            <Heart size={28} />
          </div>
          <h2 className="font-display text-2xl text-[#111111] mt-6">Votre liste de souhaits est vide</h2>
          <p className="text-xs text-[#666666] mt-2 max-w-xs mx-auto">Enregistrez les soins que vous souhaitez intégrer à votre prochain rituel.</p>
          <Link to="/shop" className="btn-queen-primary mt-6 text-xs uppercase tracking-wider">Découvrir la collection</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
